import React from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import shortid from "shortid"

import Styles from "./checkbox.less"
import createReactClass from "create-react-class"

export default createReactClass({
  propTypes: {
    className: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    isNotValid: PropTypes.bool,
    dataQa: PropTypes.string,
    dataQaProps: PropTypes.object,
    showTooltip: PropTypes.bool,
  },
  getInitialState: function () {
    return {
      inputId: shortid.generate(),
      isChecked: this.props.checked,
    }
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      isChecked: nextProps.checked,
    })
  },
  handleChange(event) {
    var isChecked = event.target.checked
    this.props.onChange && this.props.onChange(event, isChecked, this.props.value)
    this.setState({ isChecked: isChecked })
  },
  getClass() {
    return ClassNames(
      Styles.checkbox,
      {
        disabled: this.props.disabled,
        notValid: this.props.isNotValid,
      },
      this.props.className,
    )
  },
  getLabelClass() {
    return ClassNames(Styles.label, {
      checked: this.state.isChecked,
      disabled: this.props.disabled,
    })
  },
  render() {
    const inputId = this.props.inputId || this.state.inputId

    return (
      <div className={this.getClass()} title={this.props.showTooltip ? this.props.label : null}>
        <input
          id={inputId}
          type="checkbox"
          disabled={this.props.disabled}
          onChange={this.handleChange}
          checked={this.state.isChecked}
          tabIndex={this.props.tabIndex}
          autoFocus={this.props.autoFocus}
        />
        <label
          htmlFor={inputId}
          className={this.getLabelClass()}
          data-qa={this.props.dataQa}
          {...this.props.dataQaProps || {}}
          title={this.props.title}>
          <span dangerouslySetInnerHTML={{ __html: this.props.label }} />
        </label>
      </div>
    )
  },
})
